
export const TOTP = 'TOTP';
export const PASSKEY = 'PASSKEY';
export const EMAIL = 'EMAIL';

export default {
    TOTP,
    PASSKEY,
    EMAIL,
}
